import React, { Component } from "react";
import ReactDOM from "react-dom";
import { HotKeys } from "react-hotkeys";

/**
 * @description 修饰器  用于修饰pagination  使其获得快捷键的能力
 * @param  {...any} params
 */
function hotkeys(...params) {
    let hotKeyboard = !!params[0];

    let { prevPage, nextPage, ...others } = params[1] || {};

    return function(WrappedComponent) {
        const defaultProps = {
            activePage: 1,
            dataNumSelect: ["5", "10", "15", "20"],
            dataNum: 1
        };
        class WrappedPagination extends Component {
            constructor(props) {
                super(props);
                this.state = {
                    activePage: props.activePage
                };
                // 缓存每页页数
                this.dataNumCahe = props.dataNum;
            }

            componentWillReceiveProps(nextProps) {
                if (
                    !!nextProps.activePage &&
                    nextProps.activePage !== this.state.activePage
                ) {
                    this.setState({
                        activePage: nextProps.activePage
                    });
                }
                if (
                    nextProps.dataNum &&
                    this.props.dataNum !== nextProps.dataNum
                ) {
                    this.dataNumCahe = nextProps.dataNum;
                }
            }

            handleSelect(eventKey) {
                this.setState({
                    activePage: eventKey
                });
                this.props.onSelect && this.props.onSelect(eventKey);
            }

            dataNumSelect = (index, value) => {
                const { onDataNumSelect } = this.props;
                this.dataNumCahe = index;
                if (typeof onDataNumSelect === "function") {
                    onDataNumSelect(index, value);
                }
            };

            render() {
                let {
                    onSelect = () => {},
                    activePage,
                    dataNumSelect,
                    total,
                    hotkeyAttach,
                    items,
                    ncHotKeyboard = hotKeyboard
                } = this.props;
                return ncHotKeyboard ? (
                    <HotKeys
                        keyMap={{
                            rightHandler: [nextPage || "ctrl+right"],
                            leftHandler: [prevPage || "ctrl+left"]
                        }}
                        handlers={{
                            rightHandler: () => {
                                let attachElement =
                                    (typeof hotkeyAttach === "string"
                                        ? document.querySelector(hotkeyAttach)
                                        : hotkeyAttach) ||
                                    ReactDOM.findDOMNode(this.wrapped);
                                // 如果当前focus元素在
                                if (
                                    attachElement === document.activeElement ||
                                    attachElement.contains(
                                        document.activeElement
                                    )
                                ) {
                                    // console.log("nextPage trigger");
                                    let pageSize =
                                        dataNumSelect[this.dataNumCahe];
                                    items =
                                        items ||
                                        (Number.isNaN(parseInt(pageSize))
                                            ? 1
                                            : Math.ceil(total / pageSize));
                                    if (activePage < items) {
                                        this.setState({
                                            activePage: activePage + 1
                                        });
                                        onSelect(activePage + 1);
                                    }
                                }
                            },
                            leftHandler: () => {
                                let attachElement =
                                    (typeof hotkeyAttach === "string"
                                        ? document.querySelector(hotkeyAttach)
                                        : hotkeyAttach) ||
                                    ReactDOM.findDOMNode(this.wrapped);
                                // 如果当前focus元素在
                                if (
                                    attachElement === document.activeElement ||
                                    attachElement.contains(
                                        document.activeElement
                                    )
                                ) {
                                    // console.log("prevPage trigger");
                                    if (activePage > 1) {
                                        this.setState({
                                            activePage: activePage - 1
                                        });
                                        onSelect(activePage - 1);
                                    }
                                }
                            }
                        }}
                        ref={dom => (this.wrapped = dom)}
                        className="pagination-hotkeys-wrapper"
                        focused={true}
                        attach={document.body}
                        {...others}
                    >
                        <WrappedComponent
                            // ref={obj => (this.wrappedComponent = obj)}
                            {...this.props}
                            onSelect={this.handleSelect.bind(this)}
                            onDataNumSelect={this.dataNumSelect}
                            activePage={this.state.activePage}
                        />
                    </HotKeys>
                ) : (
                    <WrappedComponent
                        // ref={obj => (this.wrappedComponent = obj)}
                        {...this.props}
                        onSelect={this.handleSelect.bind(this)}
                        onDataNumSelect={this.dataNumSelect}
                        activePage={this.state.activePage}
                    />
                );
            }
        }
        WrappedPagination.defaultProps = defaultProps;
        return WrappedPagination;
    };
}

export default hotkeys;
